import { EVENTS } from '../../../../../../library';

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.COMPONENTS.APPLICATION.REWARDS.EARN.ACHIEVEMENT_CARD[event];
};

export const TRANSLATION_PATH = (route) => {
  return `components.application.rewards.earn.achievementCard.${route}`;
};
